import { WarningFilled } from '@element-plus/icons-vue';
export default {
  name: "EvmTip",
  components: {
    WarningFilled
  }
};